import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {backgroundColor} from "html2canvas/dist/types/css/property-descriptors/background-color";

@Component({
  selector: 'lib-SignageLibs',
  template: ``,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignageLibsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
